export default "__VITE_ASSET__Cwb873wb__"